import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import { createLogicMiddleware } from 'redux-logic';
import { createBrowserHistory, createMemoryHistory } from 'history';
import createRootReducer from './rootReducer';
import rootLogic from './rootLogic';
import gtmMiddleware from 'lib/analytics/gtmMiddleware';
import { ROUTER_BASE_NAME, ENVIRONMENT, GTM_ID, IS_SERVER } from 'config';
import { routeHooksMiddleware } from './middleware/routeHooksMiddleware';

export default ({ url, splitClient, cookies }) => {
  const isDevelopment = ENVIRONMENT === 'development';

  const logicMiddleware = createLogicMiddleware(rootLogic, { splitClient, cookies });
  const history = IS_SERVER ? createMemoryHistory({ initialEntries: [url] }) : createBrowserHistory({ basename: ROUTER_BASE_NAME });
  const middleware = [routeHooksMiddleware, logicMiddleware, routerMiddleware(history)];
  const enhancers = [];
  const serverDataLayer = [];

  if (GTM_ID) middleware.push(gtmMiddleware({ serverDataLayer, isServer: IS_SERVER }));

  if (isDevelopment && !IS_SERVER) {
    const { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ } = window;
    if (typeof __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
      enhancers.push(__REDUX_DEVTOOLS_EXTENSION_COMPOSE__());
    }
  }

  const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

  const initialState = !IS_SERVER ? window.PRELOADED_STORE_STATE : {};

  if (!IS_SERVER) {
    delete window.PRELOADED_STORE_STATE;
  }

  const store = createStore(createRootReducer(history), initialState, composedEnhancers);

  // Hot module reloading for redux
  if (isDevelopment && module.hot) {
    module.hot.accept('./rootReducer', () => {
      store.replaceReducer(createRootReducer(history));
    });
  }

  return {
    store,
    history,
    logicMiddleware,
    serverDataLayer,
  };
};
